var map = {
	"./esenin/1.webp": 4005,
	"./esenin/2.webp": 5475,
	"./esenin/3.webp": 2311,
	"./esenin/4.webp": 6142,
	"./esenin/5.webp": 4021,
	"./esenin/6.webp": 7063,
	"./physics/1.webp": 8962,
	"./physics/2.webp": 7082,
	"./physics/3.webp": 3422,
	"./physics/4.webp": 3416,
	"./physics/5.webp": 7138,
	"./physics/6.webp": 4707,
	"./physics/7.webp": 6020,
	"./physics/8.webp": 7743,
	"./pt-academy/1.webp": 8568,
	"./pt-academy/2.webp": 2849,
	"./pt-academy/3.webp": 1365,
	"./pt-academy/4.webp": 6553,
	"./pt-academy/5.webp": 6687,
	"./pt-academy/6.webp": 4826,
	"./pt-game/1.webp": 7726,
	"./pt-game/2.webp": 8444,
	"./pt-game/3.webp": 1948,
	"./pt-game/4.webp": 3477,
	"./pt-game/5.webp": 5298,
	"./pt-game/6.webp": 4285,
	"./pt-game/7.webp": 6126,
	"./pt-mobile/1.webp": 3415,
	"./pt-mobile/2.webp": 6811,
	"./pt-mobile/3.webp": 2354,
	"./pt-mobile/4.webp": 4924,
	"./pt-mobile/5.webp": 5921,
	"./pt-mobile/6.webp": 3121,
	"./pt-web/1.webp": 9935,
	"./pt-web/2.webp": 1658,
	"./pt-web/3.webp": 9944,
	"./pt-web/4.webp": 5969,
	"./pt-web/5.webp": 9679,
	"./pt-web/6.webp": 8569,
	"./universe-say/1.webp": 8538,
	"./universe-say/2.webp": 544,
	"./universe-say/3.webp": 4705,
	"./universe-say/4.webp": 1585,
	"./universe-say/5.webp": 1972,
	"./universe-say/6.webp": 5388,
	"./universe-say/7.webp": 5451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5195;